/* AssignLicensesModal — multi-select license assignment for a single user.
   Drives the parent's saveAssignments callback. */
import React, { useState, useEffect } from "react";
import { P, FC } from "../../shared/constants";
import Modal from "../components/Modal";
import Chip from "../components/Chip";
var E = React.createElement;

export default function AssignLicensesModal(props){
  var st = useState([]);
  var selected = st[0], setSelected = st[1];

  useEffect(function(){
    if(props.open && props.user){
      setSelected((props.user.assignedLicenses||[]).slice());
    }
  }, [props.open, props.user, setSelected]);

  if(!props.user) return null;

  function toggle(id){
    setSelected(function(prev){
      var i = prev.indexOf(id);
      if(i>=0){ var next = prev.slice(); next.splice(i,1); return next; }
      return prev.concat([id]);
    });
  }

  var licenses = props.licenses || [];

  return E(Modal,{
    open:props.open, onClose:props.onClose,
    title:"Assign licenses",
    footer:[
      E("button",{key:"cancel",type:"button",onClick:props.onClose,
        style:{padding:"8px 14px",borderRadius:8,border:"1px solid "+P.bdr,
          background:P.card,fontSize:11,fontWeight:600,cursor:"pointer",minHeight:36}},"Cancel"),
      E("button",{key:"save",type:"button",
        onClick:function(){ props.onSave && props.onSave(selected); },
        style:{padding:"8px 14px",borderRadius:8,border:"none",
          background:P.pri,color:"#fff",fontSize:11,fontWeight:700,cursor:"pointer",minHeight:36}},
        "Save assignments")
    ]
  },
    E("div",{style:{marginBottom:14}},
      E("div",{style:{fontSize:13,fontWeight:700}}, props.user.name || props.user.email || props.user.id),
      E("div",{style:{fontSize:11,color:P.slateM,fontFamily:FC,marginTop:2}}, props.user.email || props.user.id),
      E("div",{style:{fontSize:11,color:P.slateM,marginTop:6}},
        "Selected: ", E("strong",null,selected.length),
        " · Available: ", E("strong",null,licenses.length))),
    licenses.length===0
      ? E("div",{style:{padding:20,textAlign:"center",color:P.slateM,fontSize:12,
          background:P.bgS,borderRadius:10}},
          "No licenses exist yet. Create one from the Licenses tab.")
      : E("ul",{role:"group","aria-label":"Licenses",
          style:{listStyle:"none",padding:0,margin:0,display:"flex",flexDirection:"column",gap:6}},
          licenses.map(function(l){
            var id = l.id || l.domain;
            var checked = selected.indexOf(id) >= 0;
            return E("li",{key:id},
              E("label",{style:{display:"flex",alignItems:"center",gap:10,
                padding:"10px 12px",borderRadius:8,
                border:"1px solid "+(checked?P.pri:P.bdr),
                background:checked?P.priLt:P.card,cursor:"pointer"}},
                E("input",{type:"checkbox",checked:checked,
                  onChange:function(){toggle(id)},
                  style:{width:18,height:18,accentColor:P.pri}}),
                E("div",{style:{flex:1}},
                  E("div",{style:{fontSize:12,fontWeight:700}}, l.domain),
                  E("div",{style:{fontSize:11,color:P.slateM}},
                    (l.orgName||"—")+" · status: "+(l.status||"?"))),
                E(Chip,{tier:l.tier,size:"sm"}, (l.tier||"?").toUpperCase()))
            );
          }))
  );
}
